import { Search } from '../icons'
import { Button } from './Button'

type SearchInputProps = {
	label: string
	placeholder: string
	setSearch?: (search: string) => void
	isLoading?: boolean
}

export default function SearchInput({
	label,
	placeholder,
	setSearch,
	isLoading,
}: SearchInputProps) {
	return (
		<div className="flex group gap-2 pl-[15px] pr-[3px] py-[3px] border border-gray-100 dark:border-gray-700 rounded-full items-center focus-within:border-gray-600 hover:border-gray-600">
			<Search className="stroke-gray-500 dark:stroke-gray-300 w-6 h-6" />
			<input
				id="digital-twin-search-bar"
				type="search"
				className="w-full text-gray-500 hover:placeholder:text-gray-600 focus:placeholder:text-gray-600 dark:text-gray-700 placeholder:text-gray-500 dark:placeholder:text-gray-300 focus-visible:outline-none bg-transparent"
				placeholder={placeholder}
				onChange={(e) => {
					setSearch(e.target.value)
				}}
			/>
			<Button
				type="submit"
				title={label}
				noIcon
				size="sm"
				disabled={isLoading}
				className="h-10"
			>
				{label}
			</Button>
		</div>
	)
}
